import * as React from 'react';

import { IZoneCleaningHistory, IZoneCleaningHistoryItemView } from 'models';

export const useCleaningHistoryViewData = ({
  zoneId,
  cleaningHistory,
}: {
  zoneId: number;
  cleaningHistory: IZoneCleaningHistory | null;
}) =>
  React.useMemo(() => {
    let cleaningHistoryViewData: Array<IZoneCleaningHistoryItemView> = [];

    if (!cleaningHistory) {
      return [cleaningHistoryViewData];
    }

    const { currentTime, history } = cleaningHistory;

    if (history.length > 0) {
      cleaningHistoryViewData = history
        .filter((item) => (item.log && item.log.clean_code_zone_id === zoneId) || !item.log)
        .map((item) => {
          const { log_type, scheduleTime, updated_at = currentTime } = item;
          let service_item_labels: Array<string> = [];

          if (item.log) {
            const { cleaned, disinfected, refilled, serviced, sanitized } = item.log;

            if (cleaned) {
              service_item_labels.push('cleaned');
            }

            if (disinfected) {
              service_item_labels.push('disinfected');
            }

            if (refilled) {
              service_item_labels.push('refilled');
            }

            if (serviced) {
              service_item_labels.push('serviced');
            }

            if (sanitized) {
              service_item_labels.push('sanitized');
            }
          }

          service_item_labels = [...service_item_labels, ...item.service_items];

          return {
            log_type,
            scheduleTime,
            service_item_labels,
            updated_at,
            files: item.log?.files,
          } as IZoneCleaningHistoryItemView;
        });
    }

    return [cleaningHistoryViewData];
  }, [zoneId, cleaningHistory]);
